<template>
  <div class="chatBot-Wrapper">
    <!-- <button class="btn" @click="chatInit" v-if="!displayChat"> -->
    <div class="lila" v-if="showScrollUpBtn">
      <img @click="chatInit" v-if="!displayChat" src="@/assets/Icons/chatbot-guru.png" alt />
    </div>
    <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        class="chat-icon"
        style="stroke: rgb(0, 34, 87);"
      >
        <path
          d="M9.37,1.34H10.8a8.2,8.2,0,0,1,0,16.39H9.37a10,10,0,0,1-2.68-.45c-.55-.15-2.23,1.81-2.63,1.36s.05-2.79-.41-3.23q-.28-.27-.54-.57A8.2,8.2,0,0,1,9.37,1.34Z"
          style="fill: none;"
        />
        <line x1="6.37" y1="7.04" x2="12.58" y2="7.04" style="fill: none; stroke-linecap: round;" />
        <line x1="6.37" y1="9.66" x2="14.31" y2="9.66" style="fill: none; stroke-linecap: round;" />
        <line
          x1="6.37"
          y1="12.28"
          x2="11.42"
          y2="12.28"
          style="fill: none; stroke-linecap: round;"
        />
    </svg>-->
    <!-- </button> -->
    <div
      class="chat animated"
      :class="{ fadeInUp: displayChat, fadeOutDown: !displayChat }"
      v-if="chatReady"
    >
      <div class="chatbot">
        <div class="top-bar">
          <div class="heading">
            <span style="position:absolute;">
            <b-button id="tooltip-target-1" class="info-icon">i</b-button>
  <b-tooltip target="tooltip-target-1" triggers="hover">
    {{audioInfo}}
  </b-tooltip>
  </span>
            <p class="heading-para" style="margin-left: calc((100% - 175px)/2);">💬 Chat with Guru!</p>
            <div class="language-switch-container" @click="toggleLanguageScreen" style="margin-right: 40px;">
              <img class="dot" src="@/assets/home-page-images/language-symbol.svg" alt />
              <img class="dot" src="@/assets/home-page-images/dropdown-arrow.svg" alt />
            </div>
          </div>
          <!--<img class="dot" src="@/assets/minus.png" alt @click="displayChat = !displayChat" />-->
          <div class="dot window-close" id="window-close" @click="toggleChat">
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              title="close the chat"
              style="background: #f1f1f1;"
            >
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </div>
        </div>
        <div v-if="!showLanguageScreen" class="responses py-2 pl-1" id="responses">
          <div class="res-list" v-for="(res, i) in responses" :key="i">
            <div
              class="d-flex my-2 flex-row-reverse"
              v-if="res.user != undefined && res.user.msg.length > 0"
            >
              <div class="res user p-auto">
                <app-user :res="res.user"></app-user>
              </div>
            </div>
            <div
              class="d-flex my-1 flex-row"
              v-if="res.bot != undefined && res.bot.data.text.length > 0"
            >
              <div class="res bot p-auto">
                <app-bot :res="res.bot" :lang="langCode" @getUserInput="getCallback($event)" @btnPayload="btnClick"></app-bot>
              </div>
            </div>
          </div>
          <div v-if="typing" class="d-flex my-1 flex-row">
            <div class="res bot p-auto">
              <div>
                <div class="timestamp">Guru is typing ...</div>
                <div id="bot" class="row">
                  <div class="col-sm-1">
                    <img class="avatarL d-inline" src="@/assets/home-page-images/guru.png" alt />
                  </div>
                  <div class="pl-4 ml-3">
                    <!-- <img src="@/assets/larsenLogo.png" alt=""> -->
                    <sync-loader
                      :loading="true"
                      color="#1e2837"
                      class="text-center"
                      size="6px"
                      width="10px"
                    ></sync-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else></div>
        </div>
        <div v-else class="responses py-2 pl-1" id="responses">
          <h6 style="text-align: center; color: #a5a5a5;">Select your Chat Language</h6>
          <div class="bot-grid-container bot-grid-container--fit">
            <template v-for="(lan, index) in languageList">
              <div class="bot-grid-element" :key="'Lang' + index" @click="switchLanguage(index)">
                <h6 style="vertical-align: middle; line-height: 45px;">{{ lan.languageText }}</h6>
              </div>
            </template>
          </div>
        </div>
        <div v-if="responses.length == 0 && !showLanguageScreen" class="text-center">
          <img style="max-width: 150px; padding:40px" src="@/assets/home-page-images/guru.png" alt />
          <pulse-loader :loading="botLoading" color="#1e2837" class="text-center"></pulse-loader>
          <div class="getting-ready">{{ botStatusMsg }}</div>
        </div>
        <!-- <footer class="card-footer">
          <form action @submit.prevent>
            <div>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control user-input-box py-4"
                  id="inlineFormInputGroup"
                  placeholder="Type your Query here..."
                  v-model="userInput"
                  @keyup.enter="chatResponse"
                />
                <div class="input-group-append" @click.prevent="chatResponse">
                  <span class="input-group-text search_btn">
                    <div class="send">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                        xml:space="preserve"
                        class
                        style="fill: rgb(0, 0, 0);"
                      >
                        <path
                          d="M22,11.7V12h-0.1c-0.1,1-17.7,9.5-18.8,9.1c-1.1-0.4,2.4-6.7,3-7.5C6.8,12.9,17.1,12,17.1,12H17c0,0,0-0.2,0-0.2c0,0,0,0,0,0c0-0.4-10.2-1-10.8-1.7c-0.6-0.7-4-7.1-3-7.5C4.3,2.1,22,10.5,22,11.7z"
                        />
                      </svg>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </footer>-->
        <footer class="card-footer">
          <span style="cursor:pointer;position: absolute;top: -25px;right: 10px; z-index: 100000;">
            <i
              @click="againInit()"
              class="material-icons cursor-pointer"
              style="vertical-align:middle;width: 30px;height: 30px;"
            >home</i>
          </span>
          <form action @submit.prevent>
            <div>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control user-input-box py-4"
                  id="inlineFormInputGroup"
                  placeholder="Type your Query here..."
                  v-model="userInput"
                  @keyup.enter="chatResponse"
                />
                <div class="input-group-append">
                  <span class="input-group-text search_btn" @click.prevent="chatResponse">
                    <div class="send">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                        xml:space="preserve"
                        class
                        style="fill: rgb(0, 0, 0);"
                      >
                        <path
                          d="M22,11.7V12h-0.1c-0.1,1-17.7,9.5-18.8,9.1c-1.1-0.4,2.4-6.7,3-7.5C6.8,12.9,17.1,12,17.1,12H17c0,0,0-0.2,0-0.2c0,0,0,0,0,0c0-0.4-10.2-1-10.8-1.7c-0.6-0.7-4-7.1-3-7.5C4.3,2.1,22,10.5,22,11.7z"
                        />
                      </svg>
                    </div>
                  </span>
                  <span
                    class="input-group-text search_btn"
                    id="startRecButton"
                    @click="updateTimer()"
                  >
                    <div v-if="this.recording && !this.loading" class="send1 recording">
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 58 58"
                        style="enable-background:new 0 0 58 58;"
                        xml:space="preserve"
                      >
                        <g>
                          <path
                            d="M44,28c-0.552,0-1,0.447-1,1v6c0,7.72-6.28,14-14,14s-14-6.28-14-14v-6c0-0.553-0.448-1-1-1s-1,0.447-1,1v6
		c0,8.485,6.644,15.429,15,15.949V56h-5c-0.552,0-1,0.447-1,1s0.448,1,1,1h12c0.552,0,1-0.447,1-1s-0.448-1-1-1h-5v-5.051
		c8.356-0.52,15-7.465,15-15.949v-6C45,28.447,44.552,28,44,28z"
                          />
                          <path
                            d="M29,46c6.065,0,11-4.935,11-11V11c0-6.065-4.935-11-11-11S18,4.935,18,11v24C18,41.065,22.935,46,29,46z"
                          />
                        </g>
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                      </svg>
                    </div>
                    <div v-else-if="!this.loading" class="send1 not-recording">
                      <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512.001 512.001"
                        style="enable-background:new 0 0 512.001 512.001;"
                        xml:space="preserve"
                      >
                        <g>
                          <g>
                            <path
                              d="M412.113,170.747c-6.637,0-12.02,5.381-12.02,12.02v75.104c0,79.452-64.639,144.09-144.092,144.09
			S111.91,337.321,111.91,257.87v-75.104c0-6.639-5.383-12.02-12.02-12.02c-6.639,0-12.02,5.381-12.02,12.02v75.104
			c0,88.666,68.993,161.512,156.111,167.696v62.395h-62.174c-6.637,0-12.02,5.381-12.02,12.02c0,6.639,5.382,12.02,12.02,12.02
			h148.386c6.637,0,12.02-5.381,12.02-12.02c0-6.639-5.382-12.02-12.02-12.02H268.02v-62.395
			c87.119-6.184,156.111-79.031,156.111-167.696v-75.104C424.133,176.128,418.75,170.747,412.113,170.747z"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M264.011,0h-16.02c-54.949,0-99.653,44.704-99.653,99.653V265.88c0,54.949,44.704,99.653,99.653,99.653h16.02
			c54.949,0,99.653-44.704,99.653-99.653V99.653C363.664,44.704,318.96,0,264.011,0z M339.625,130.853h-43.572
			c-6.639,0-12.02,5.381-12.02,12.02c0,6.639,5.381,12.02,12.02,12.02h43.572v33.458h-43.572c-6.639,0-12.02,5.381-12.02,12.02
			s5.381,12.02,12.02,12.02h43.572v33.46h-43.572c-6.639,0-12.02,5.381-12.02,12.02s5.381,12.02,12.02,12.02h43.464
			c-2.091,39.836-35.157,71.603-75.505,71.603h-16.02c-40.348,0-73.414-31.767-75.505-71.603h43.464
			c6.639,0,12.02-5.381,12.02-12.02s-5.381-12.02-12.02-12.02h-43.572v-33.46h43.572c6.639,0,12.02-5.381,12.02-12.02
			s-5.381-12.02-12.02-12.02h-43.572v-33.458h43.572c6.639,0,12.02-5.381,12.02-12.02c0-6.639-5.381-12.02-12.02-12.02h-43.572
			v-31.2c0-29.964,17.52-55.914,42.854-68.143v33.983c0,6.639,5.382,12.02,12.02,12.02s12.02-5.381,12.02-12.02V24.558
			c2.863-0.331,30.595-0.331,33.458,0v40.935c0,6.639,5.381,12.02,12.02,12.02c6.637,0,12.02-5.381,12.02-12.02V31.51
			c25.334,12.229,42.854,38.177,42.854,68.142V130.853z"
                            />
                          </g>
                        </g>
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                      </svg>
                    </div>
                    <div v-show="this.loading" class="send1 not-recording loader">
                      <img src="../../assets/voiceloader.gif" width="15px" alt="loader" />
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
// import { ChatService } from "../services/ChatService";
import axios from "axios";
//import uuid from "uuid";
import UserVue from "./ChatWindow/User.vue";
import BotVue from "./ChatWindow/Bot.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
import { setTimeout } from "timers";
// import { truncate } from 'fs';
// const chatService = new ChatService();

export default {
  components: {
    appUser: UserVue,
    appBot: BotVue,
    PulseLoader,
    SyncLoader
  },
  props: ["activeModule"],
  data() {
    return {
      bufferSize: 2048,
      AudioContext: null,
      context: null,
      processor: null,
      input: null,
      globalStream: false,
      streamStreaming: false,
      constraints: {
        audio: true,
        video: false
      },
      loading: false,
      _socket: null,
      recording: false,
      displayChat: false,
      chatReady: false,
      botReady: false,
      botLoading: true,
      botStatusMsg: "Guru getting Ready!",
      typing: false,
      sender: "",
      resHolder: {},
      botRes: "",
      userInput: "",
      message: "",
      audioControl: null,
      url: "chatbot/api/bot",
      langCode: "en-IN",
      showLanguageScreen: false,
      showScrollUpBtn: true,
      languageList: [
        {
          languageText: "English",
          langCode: "en-IN"
        },
        {
          languageText: "हिंदी",
          langCode: "hi-IN"
        },
        {
          languageText: "தமிழ்",
          langCode: "ta-IN"
        },
        {
          languageText: "తెలుగు",
          langCode: "te-IN"
        }
      ],
      selectedLanguageIndex: 0,
      responses: [
        // {
        //   bot: "Hello! I am LiLa, How can I help You 1??",
        //   user: "hey!"
        // }
      ],
      pageName: "",
      string_extension: "page_",
      audioInfo: "Guru replies are read out as voice too. Kindly turn up the volume if required."
    };
  },
  watch: {
    $route() {
      this.botReady = false;
      this.pageName = this.$route.name;
      this.pageName = this.string_extension.concat(this.pageName);
      console.log(this.pageName);
      this.getPageStatus();
      this.displayChat = false;
      // clears the chat history
      this.responses = [];
      //this.againInit();
    },
    activeModule: function(newVal, oldVal) {
      if (newVal != oldVal) {
        var moduleName = this.string_extension.concat(newVal);
        this.getActiveModuleStatus(moduleName);
      }
    }
  },
  updated() {
    this.scrollToEnd();
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
    if (this.activeModule) {
      var moduleName = this.string_extension.concat(this.activeModule);
      this.getActiveModuleStatus(moduleName);
    }    
    var self = this
    EventBus.$on('stopAudio',function(){
      if (self.audioControl != null) {
        self.audioControl.pause();
      }
    });
    $(document).ready(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      // if (
      //   this.pageName == "page_partnerProfile" ||
      //   this.pageName == "page_PartnerFeedback" ||
      //   this.pageName == "page_PartnerSummary" ||
      //   this.pageName == "page_partnerApprovalPage" ||
      //   this.pageName == "page_Summary"
      // ) {
      //   const scrollingEvent = document.scrollingElement.scrollTop;
      //   console.log(scrollingEvent);
      //   this.showScrollUpBtn = scrollingEvent < 70;
      //   console.log("dontenable");
      //   console.log(this.showScrollUpBtn);
      // } else {
      //   console.log("enableLIla");
      //   this.showScrollUpBtn = true;
      // }
      // return true;
      const scrollingEvent = document.scrollingElement.scrollTop;
      this.showScrollUpBtn = scrollingEvent < 50;
    },
    getPageStatus() {
      if (
        this.pageName == "page_dashboard" ||
        this.pageName == "page_partnerProfile" ||
        this.pageName == "page_PartnerSummary" ||
        this.pageName == "page_PartnerAuction" ||
        this.pageName == "page_PartnerReminer" ||
        this.pageName == "page_PartnerInvoice" ||
        this.pageName == "page_PartnerFeedback"
      ) {
        this.pageName = "page_Partner_dashboard";
      } else if (this.pageName == "page_DashboardPage") {
        this.pageName = "page_dashboard";
      } else if (this.pageName == "page_Login") {
        this.pageName = "page_loginPage";
      }
      if (!sessionStorage.getItem("uniqueID")) {
        this.sender = sessionStorage.setItem(
          "uniqueID",
          "User-" +
            Math.floor(Math.random() * (999 - 100 + 1) + 100) +
            "-" +
            new Date().getTime()
        );
      } else {
        this.sender = sessionStorage.getItem("uniqueID");
      }
      //this.getPageStatusAPICall();
    },
    getPageStatusAPICall(){
      axios({
        method: "post",
        url: this.url, timeout:8000,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          lang: this.langCode
        },
        data: {
          sender: window.btoa(this.sender),
          message: this.pageName
        }
      })
        .then(res => {})
        .catch(e => {});
    },
    getActiveModuleStatus(moduleName) {
      if (!sessionStorage.getItem("uniqueID")) {
        this.sender = sessionStorage.setItem(
          "uniqueID",
          "User-" +
            Math.floor(Math.random() * (999 - 100 + 1) + 100) +
            "-" +
            new Date().getTime()
        );
      } else {
        this.sender = sessionStorage.getItem("uniqueID");
      }
      axios({
        method: "post",
        url: this.url, timeout:8000,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          lang: this.langCode
        },
        data: {
          sender: window.btoa(this.sender),
          message: moduleName
        }
      })
        .then(res => {})
        .catch(e => {});
    },
    updateTimer() {
      if (!this.recording) {
        // setTimeout(()=>{this.micClick()}, 3000);
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 3000);
        this.micClick();
      } else this.micClick();
    },
    micClick() {
      if (this.audioControl != null) {
        this.audioControl.pause();
      }
      if (this.recording) {
        this.stopRecording(this._socket);
      } else {
        this.recording = !this.recording;
        this.startRecording();
      }
    },
    initRecording() {
      const socket = new WebSocket(
        process.env.VUE_APP_CHATBOT_URL + this.langCode,
        "stream"
      );
      this._socket = socket;
      socket.onerror = e => {};
      socket.onclose = e => {};
      socket.onopen = () => {
        //  this.recording = !this.recording;
        var msg = "startGoogleCloudStream";
        socket.send(msg); //init socket Google Speech Connection
        this.streamStreaming = true;
        this.AudioContext = window.AudioContext || window.webkitAudioContext;
        this.context = new AudioContext({
          // if Non-interactive, use 'playback' or 'balanced' // https://developer.mozilla.org/en-US/docs/Web/API/AudioContextLatencyCategory
          latencyHint: "interactive"
        });
        this.processor = this.context.createScriptProcessor(
          this.bufferSize,
          1,
          1
        );
        this.processor.connect(this.context.destination);
        this.context.resume();
        var handleSuccess = stream => {
          this.globalStream = stream;
          this.input = this.context.createMediaStreamSource(stream);
          this.input.connect(this.processor);
          this.processor.onaudioprocess = e => {
            var left = e.inputBuffer.getChannelData(0);
            // var left16 = convertFloat32ToInt16(left); // old 32 to 16 function
            var left16 = this.downsampleBuffer(left, 44100, 16000);

            socket.send(left16);
          };
        };
        navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(handleSuccess);
      };
      return socket;
    },
    startRecording() {
      var socket = this.initRecording();
      /*  var stopRecording = ()=> {
        this.recording = this.recording; 
        this.streamStreaming = false;
        var msg = "stopGoogleCloudStream";
        socket.send(msg);
        let track = this.globalStream.getTracks()[0];
        track.stop();
        this.input.disconnect(this.processor);
        this.processor.disconnect(this.context.destination);
        this.context.close().then(() => {
            this.input = null;
            this.processor = null;
            this.context = null;
            this.AudioContext = null;
            this.recording = this.recording;
          });
        };*/
      socket.onmessage = e => {
        //  let words_n_time = [];
        //let newSpan = document.createElement('span');
        //  newSpan.innerHTML = JSON.stringify(e.data);
        //  console.log(e.data);
        // words_n_time.push(newSpan);
        // let edit = words_n_time;
        //console.log(this.resHolder);
        //for (var i = 0; i < edit.length; i++) {
        /*   if (i === 0) {
                edit[i].innerText = capitalize(edit[i].innerText)
            }
            resultText.lastElementChild.appendChild(edit[i]);
            if (i !== edit.length - 1) {
                resultText.lastElementChild.appendChild(document.createTextNode('\u00A0'));
            }*/
        // elem.scrollTop = elem.scrollHeight;
        //this.resHolder.bot = { data: e.data, time: new Date() };
        //this.responses.push(this.resHolder);
        //this.resHolder = {};
        this.stopRecording(socket);
        this.userInput = e.data;
        this.chatResponse();
        //}
      };
    },
    stopRecording(socket) {
      this.recording = false;
      this.streamStreaming = false;
      var msg = "stopGoogleCloudStream";
      socket.send(msg);
      let track = this.globalStream.getTracks()[0];
      track.stop();
      this.input.disconnect(this.processor);
      this.processor.disconnect(this.context.destination);
      this.input = null;
      this.processor = null;
      this.AudioContext = null;
      this.context.close().catch(e => {});
      this.context = null;
    },
    downsampleBuffer(buffer, sampleRate, outSampleRate) {
      if (outSampleRate == sampleRate) {
        return buffer;
      }
      if (outSampleRate > sampleRate) {
        throw "downsampling rate show be smaller than original sample rate";
      }
      var sampleRateRatio = sampleRate / outSampleRate;
      var newLength = Math.round(buffer.length / sampleRateRatio);
      var result = new Int16Array(newLength);
      var offsetResult = 0;
      var offsetBuffer = 0;

      while (offsetResult < result.length) {
        var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
        var accum = 0,
          count = 0;
        for (
          var i = offsetBuffer;
          i < nextOffsetBuffer && i < buffer.length;
          i++
        ) {
          accum += buffer[i];
          count++;
        }

        result[offsetResult] = Math.min(1, accum / count) * 0x7fff;
        offsetResult++;
        offsetBuffer = nextOffsetBuffer;
      }
      return result.buffer;
    },
    scrollToEnd() {
      //var container = this.$el.querySelector("#responses");
      //container.scrollTop = container.scrollHeight;
      // prevent scroll to end in longer responses
  var container = document.getElementById('responses')
  var nodes = document.querySelectorAll('.res-list');
  var last = nodes[nodes.length- 1];
  if (last !== undefined && container !== undefined) {
  container.scrollTop = container.scrollHeight-last.offsetHeight-250
  }

    },
    btnClick(data) {
      if (this.botReady) {
        let time = new Date();
        let triggerTime = time.getTime();
        this.typing = true;
        this.resHolder.user = { msg: data.title, time: new Date() };
        this.responses.push(this.resHolder);
        this.resHolder = {};
        this.scrollToEnd();
        if (!sessionStorage.getItem("uniqueID")) {
          this.sender = sessionStorage.setItem(
            "uniqueID",
            "User-" +
              Math.floor(Math.random() * (999 - 100 + 1) + 100) +
              "-" +
              new Date().getTime()
          );
        } else {
          this.sender = sessionStorage.getItem("uniqueID");
        }
        axios({
          method: "post",
          url: this.url, timeout:8000,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
            lang: this.langCode
          },
          data: {
            sender: window.btoa(this.sender),
            message: data.payload
          }
        })
          .then(res => {
            let time = new Date();
            let responseTime = time.getTime();
            setTimeout(() => {
              this.typing = false;
              if (res.data && res.data.length > 0) {
                res.data.forEach(res => {
                  this.resHolder.bot = { data: res, time: new Date() };
                  this.responses.push(this.resHolder);
                  this.resHolder = {};
                });
              } else {
                throw "Bad API response!";
              }
            }, 800 - (responseTime - triggerTime));
          })
          .catch(e => {
            this.typing = false;
            this.botReady = false;
            this.resHolder.bot = {
              data: {
                text: "I have trouble connecting... Please Try again later!"
              },
              time: new Date()
            };
            this.responses.push(this.resHolder);
            this.resHolder = {};
            // console.log(e);
            setTimeout(() => {
              // this.displayChat = false;
              this.botReady = true;
              this.userInput = "";
            }, 3000);
          });
        this.scrollToEnd();
      }
    },
    chatResponse() {
      this.userInput = this.userInput.trim();
      if (this.userInput.trim().length > 0 && this.botReady) {
        /*let chatRequest = JSON.stringify({
        sender: window.btoa(this.sender),
        message: this.userInput
      });*/
        let time = new Date();
        let triggerTime = time.getTime();
        this.typing = true;
        this.resHolder.user = { msg: this.userInput, time: new Date() };
        this.responses.push(this.resHolder);
        this.resHolder = {};
        this.scrollToEnd();
        if (!sessionStorage.getItem("uniqueID")) {
          this.sender = sessionStorage.setItem(
            "uniqueID",
            "User-" +
              Math.floor(Math.random() * (999 - 100 + 1) + 100) +
              "-" +
              new Date().getTime()
          );
        } else {
          this.sender = sessionStorage.getItem("uniqueID");
        }
        axios({
          method: "post",
          url: this.url, timeout:8000,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
            lang: this.langCode
          },
          data: {
            sender: window.btoa(this.sender),
            message: this.userInput.trim()
          }
        })
          .then(res => {
            let time = new Date();
            let responseTime = time.getTime();
            setTimeout(() => {
              this.typing = false;
              if (res.data && res.data.length > 0) {
                res.data.forEach(element => {
                  this.resHolder.bot = { data: element, time: new Date() };
                  this.responses.push(this.resHolder);
                  this.resHolder = {};
                });
              } else {
                throw "Bad API response!";
              }
              // console.log("API response time : "+(responseTime-triggerTime));
              // console.log("Render delay : "+(800-(responseTime-triggerTime)));
              this.getTextForSpeech(res);
            }, 800 - (responseTime - triggerTime));
          })
          .catch(e => {
            this.typing = false;
            this.botReady = false;
            this.resHolder.bot = {
              data: {
                text: "I have trouble connecting... Please Try again later!"
              },
              time: new Date()
            };
            this.responses.push(this.resHolder);
            this.resHolder = {};
            // console.log(e);
            setTimeout(() => {
              // this.displayChat = false;
              this.botReady = true;
              this.userInput = "";
            }, 3000);
          });
        this.scrollToEnd();
        this.userInput = "";
      }
    },
    getCallback(event) {
      var userinput =
        event.name +
        "," +
        event.companyName +
        "," +
        event.mobile +
        "," +
        event.email;
      if (userinput) {
        axios({
          method: "post",
          url: this.url, timeout:8000,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
            lang: this.langCode
          },
          data: {
            sender: window.btoa(this.sender),
            message: userinput
          }
        })
          .then(res => {
            if (res.data && res.data.length > 0) {
              this.resHolder.bot = { data: res.data[0], time: new Date() };
              this.responses.push(this.resHolder);
              this.resHolder = {};
              this.scrollToEnd();
            } else {
              throw "Bad API response!";
            }
          })
          .catch(e => {
            this.botLoading = false;
            this.botStatusMsg = "Trouble connecting Guru! Try again later...";
            // console.log(e);
            setTimeout(() => {
              // this.displayChat = false;
              // this.botLoading = true;
              this.userInput = "";
              // this.botStatusMsg = "LiLA getting Ready!";
            }, 3000);
          });
      }
    },
    againInit() {
      axios({
        method: "post",
        url: this.url, timeout:8000,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          lang: this.langCode
        },
        data: {
          sender: window.btoa(this.sender),
          message: "start"
        }
      })
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.resHolder.bot = { data: res.data[0], time: new Date() };
            this.responses.push(this.resHolder);
            this.resHolder = {};
            this.scrollToEnd();
          } else {
            throw "Bad API response!";
          }
        })
        .catch(e => {
          this.botLoading = false;
          this.botStatusMsg = "Trouble connecting Guru! Try again later...";
          // console.log(e);
          setTimeout(() => {
            // this.displayChat = false;
            // this.botLoading = true;
            this.userInput = "";
            // this.botStatusMsg = "LiLA getting Ready!";
          }, 3000);
        });
    },
    getTextForSpeech(res) {
      var speechText = "";
      if (res.data && res.data.length > 0) {
        res.data.forEach(element => {
          console.log("response Element {}", element);
          console.log("response Element Text {}", element.text);
          speechText = speechText + " " + element.text + ". ";
          if (element.buttons && element.buttons.length > 0) {
            element.buttons.forEach((button, index) => {
              console.log("Element button {}", button);
              console.log("Element button title {}", button.title);
              //speechText = speechText + " " + (index+1) + ". " + button.title +"\n";
              speechText = speechText + " " + button.title + ". \n";
            });
          }
        });
      } else {
        speechText = "Bad API response!";
      }
      //console.log(" Final text:{}", speechText);
      this.utterChatResponse(speechText);
    },
    utterChatResponse(textMessage) {
      textMessage = textMessage.replace("<b>", "");
      textMessage = textMessage.replace("</b>", "");
      var speech = new SpeechSynthesisUtterance(textMessage);
      // speech.voice = "Google हिन्दी";
      /*  var voices = window.speechSynthesis.getVoices();
      voices.forEach((voice, index) => {
        console.log(voice.name + "::" + index);
      });
      speech.voice = voices[9]; //Google Hindi 
      speech.rate = parseFloat(0.9);

     // speech.lang = this.langCode;
      window.speechSynthesis.speak(speech);*/
      axios({
        method: "post",
        url: this.url + "/texttospeech",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          lang: this.langCode,
          Accept: "audio/mpeg"
        },
        data: {
          textmessage: textMessage
        },
        timeout: 100000
      })
        .then(async response => {
          console.log("Chat App Audio Response::", response);
          /*  window.AudioContext = window.AudioContext || window.webkitAudioContext;
            var context = new AudioContext();
            var source = context.createBufferSource(); // creates a sound source
            source.buffer = response;     // tell the source which sound to play
            source.connect(context.destination);       // connect the source to the context's destination (the speakers)
            source.start(0); */
          //  const audioContext = this.getAudioContext();
          // create audioBuffer (decode audio file)
          // const audioBuffer = await audioContext.decodeAudioData(response);

          // create audio source
          //const source = audioContext.createBufferSource();
          // source.buffer = audioBuffer;
          // source.connect(audioContext.destination);
          // play audio
          // source.start();
          
          if (this.audioControl != null) {
            this.audioControl.pause();
          }
          this.audioControl = new Audio(
            "data:audio/mp3;base64," + response.data
          );
          // console.log(snd);
          this.audioControl.play();

          //var decodedString = WindowOrWorkerGlobalScopeatob(response);
          /* console.log("Response Data", response.data);

          var decodedString = Buffer.from(response.data, 'base64').toString('binary');

          console.log(decodedString);

          const audioContext = this.getAudioContext();
            // create audioBuffer (decode audio file)
          const audioBuffer = await audioContext.decodeAudioData(decodedString);

            // create audio source
          const source = audioContext.createBufferSource();
          source.buffer = audioBuffer;
          source.connect(audioContext.destination);
            // play audio
          source.start();*/
        })
        .catch(e => {
          console.log("error occured while converting text to speech: {}", e);
        });
    },
    chatInit() {
      this.displayChat = true;
      this.pageName = this.$route.name;
      this.pageName = this.string_extension.concat(this.pageName);
      this.getWelcomeMessage();
      this.chatReady = true;
    },
    toggleChat() {
      if (this.audioControl != null) {
        this.audioControl.pause();
      }
      this.displayChat = !this.displayChat;
    },
    getWelcomeMessage() {
      if (!this.botReady) {
        if (!sessionStorage.getItem("uniqueID")) {
          this.sender = sessionStorage.setItem(
            "uniqueID",
            "User-" +
              Math.floor(Math.random() * (999 - 100 + 1) + 100) +
              "-" +
              new Date().getTime()
          );
        } else {
          this.sender = sessionStorage.getItem("uniqueID");
        }
        this.getPageStatusAPICall();
        axios({
          method: "post",
          url: this.url, timeout:8000,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
            lang: this.langCode
          },
          data: {
            sender: window.btoa(this.sender),
            message: "start"
          }
        })
          .then(res => {
            if (res.data && res.data.length > 0) {
              this.resHolder.bot = { data: res.data[0], time: new Date() };
              this.responses.push(this.resHolder);
              this.resHolder = {};
              this.botReady = true;
              this.scrollToEnd();
            } else {
              throw "Bad API response!";
            }
          })
          .catch(e => {
            this.botLoading = false;
            this.botStatusMsg = "Trouble connecting Guru! Try again later...";
            // console.log(e);
            setTimeout(() => {
              // this.displayChat = false;
              // this.botLoading = true;
              this.userInput = "";
              // this.botStatusMsg = "LiLA getting Ready!";
            }, 3000);
          });
      }
    },
    toggleLanguageScreen() {
      this.showLanguageScreen = !this.showLanguageScreen;
    },
    switchLanguage(languageIndex) {
      if (this.selectedLanguageIndex !== languageIndex) {
        this.botLoading = true;
        this.botStatusMsg = "Guru getting Ready!";
        this.selectedLanguageIndex = languageIndex;
        this.chatReady = false;
        this.botReady = false;
        this.langCode = this.languageList[this.selectedLanguageIndex].langCode;
        if (this.langCode == 'hi-IN') {
          this.audioInfo = "गुरु के जवाबों को आवाज के रूप में भी पढ़ा जाता है। आवश्यकता होने पर ध्वनि बढ़ाएं।"
        }
        if (this.langCode == 'ta-IN') {
          this.audioInfo = "குரு பதில்கள் குரலாகவும் படிக்கப்படுகின்றன. தேவைப்பட்டால் தயவுசெய்து ஒலியை அதிகரிக்கவும்."
        }
        if (this.langCode == 'te-IN') {
          this.audioInfo = "గురు ప్రత్యుత్తరాలు వాయిస్‌గా కూడా చదవబడతాయి. అవసరమైతే దయచేసి ధ్వనిని పెంచండి."
        }
        if (this.activeModule) {
          var moduleName = this.string_extension.concat(this.activeModule);
          this.getActiveModuleStatus(moduleName);
        } else {
          this.pageName = this.$route.name;
          this.pageName = this.string_extension.concat(this.pageName);
          this.getPageStatus();
          this.getPageStatusAPICall();
        }
        this.responses = [];
        this.chatInit();
      }
      this.showLanguageScreen = false;
    }
  }
};
</script>
<style>.tooltip{z-index: 99999999999999 !important;}
.tooltip-inner {
  background-color: #00acd6 !important;
  font-size:14px;
  /*!important is not necessary if you place custom.css at the end of your css calls. For the purpose of this demo, it seems to be required in SO snippet*/
  color: #fff;
}

.tooltip.top .tooltip-arrow {
  border-top-color: #00acd6;
}

.tooltip.right .tooltip-arrow {
  border-right-color: #00acd6;
}

.tooltip.bottom .tooltip-arrow {
  border-bottom-color: #00acd6;
}

.tooltip.left .tooltip-arrow {
  border-left-color: #00acd6;
}
.tooltip .tooltip-arrow {border-top: 5px solid #00acd6 !important;}
</style>
<style scoped>
.chatBot-Wrapper {
  right: 0px;
  bottom: 0px;
  width: 0px;
  height: 0;
  /* min-height: 0px!important;*/
  max-height: 0px;
}
.chatBot-Wrapper .card {
  border: 0px !important;
  background: #e9ecf0;
}
/*.chatBtn img {
  width: 32px;
  vertical-align: unset;
  margin: 5px 3px 0 3px;
}*/
svg.chat-icon {
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  width: 30px;
  height: 40px;
}
.lila {
  z-index: 100000;
  position: fixed;
  bottom: 2%;
  right: 2%;
  display: block;
  /* backface-visibility: hidden; */
  animation: shake 4s ease-in-out infinite;
  transform-origin: 50% 50%;
}
.chatBtn {
  /* animation: bg-move 15s ease-in-out infinite; */
  background-color: transparent !important;
  position: fixed;
  bottom: 5%;
  right: 5%;
  border-radius: 50%;
  z-index: 100000;
  display: block;
  border-radius: 100%;
  cursor: pointer;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  cursor: pointer;
  backface-visibility: hidden;
  animation: shake 4s ease-in-out infinite;
  /* transform-origin: 50% 50%; */
}
/* .animate-area:hover {
  transform: scale(1.1) !important;
} */
@keyframes shake {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

/* .chatBtn {
  border: 1px solid rgba(0, 0, 0, 0.125);
} */
.chat {
  position: fixed;
  left: auto;
  right: 15px;
  bottom: 15px;
  width: 370px;
  height: calc(100% - 30px);
  /*min-height: 250px!important;*/
  max-height: 550px;
  backface-visibility: hidden;
  /*padding: 1em;*/
  z-index: 100000;
  animation-duration: 0.5s;
  border-radius: 10px;
  -webkit-box-shadow: 0 16px 18px rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0 16px 18px rgba(0, 0, 0, 0.2) !important;
}
#bot .col-sm-1 {
  max-width: 8% !important;
}
.chatbot {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0px;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 16px;
  overflow: hidden;
  border-radius: 10px;
  background: rgb(233, 238, 244);
}
.top-bar {
  background: linear-gradient(to left, #002257, rgba(68, 94, 133, 0.95));
  -webkit-box-pack: center;
  justify-content: center;
  width: 100%;
  position: relative;
  z-index: 2;
  background-color: rgb(255, 255, 255);
  color: rgb(66, 77, 87);
  font-size: 1em;
  height: 50px;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  flex-grow: 0;
  text-align: left;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  font-weight: 700 !important;
  border-width: initial;
  border-style: initial;
  border-color: rgb(0, 0, 0);
  border-image: initial;
  padding: 0px 0.8em;
  transition: background-color 0.3s ease 0s;
}
.top-bar .window-close {
  cursor: pointer;
  z-index: 8;
  position: absolute;
  display: block;
  width: 30px;
  height: 30px;
  right: 13px;
  top: 10px;
  padding: 3px;
  border-radius: 100%;
}
.top-bar .window-close svg {
  padding: 3px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  width: 80%;
  height: 80%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  cursor: pointer;
  border-radius: 100%;
}
.top-bar .heading {
  width: 100%;
  text-align: center;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  font-size: 16px;
  white-space: nowrap;
  font-family: "Source Sans Pro", sans-serif !important;
  text-overflow: ellipsis;
  margin-top: 12px;
  overflow: hidden;
  letter-spacing: 1px;
  color: white;
}
.user-input-box {
  border: 0px !important;
}
.send {
  display: block;
  width: 27px;
  height: 100%;
  float: left;
}
.send :hover {
  fill: #002257;
}
.card-footer {
  bottom: 0;
  position: absolute;
  padding: 0;
  width: 100%;
  border-top: 0;
}
.card-footer .search_btn {
  font-size: 20px;
  /*padding: 10px 15px;*/
  cursor: pointer;
  background-color: #ffffff !important;
  border: 0px !important;
}
.responses {
  overflow-y: scroll;
  margin-bottom: 48px;
  overflow-x: hidden;
  margin-top: 2px;
}
.responses::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.responses::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

.responses::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(153, 153, 153, 0.2);
}
@media (max-width: 420px) {
  .chat {
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    max-height: 100%;
  }
  .chatBot-Wrapper {
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    max-height: 100%;
  }
}
.getting-ready {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 14px;
  color: #a5a5a5;
  margin-top: 10px;
}

.avatarL {
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  text-align: center;
  font-size: 0.7em;
  line-height: 1.6em;
  max-width: 35px;
  -webkit-box-flex: 0;
  flex-grow: 0;
  margin: 0px 0.3em 0px 0px;
  padding: 6px;
}

#bot .card img {
  margin: 3px 10px;
  width: 80px;
}
#bot .card {
  border-radius: 19px;
  padding: 5px 0px 7px 0px;
}
.timestamp {
  text-align: left;
  margin-left: 6px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 14px;
  color: #a5a5a5;
  margin-bottom: 4px;
}
.send1 {
  display: block;
  width: 27px;
  height: 100%;
  float: left;
}

.recording {
  fill: #dc3f40 !important;
}

.heading-para {
  display: inline-block;
  margin: 3px 10px 10px 10px;
}
.language-switch-container {
  cursor: pointer;
  display: inline-block;
  background: white;
  float: right;
  border-radius: 15px;
  height: 26px;
  width: 50px;
  margin: 1px 30px 10px 10px;
}
.bot-grid-container {
  display: grid;
  grid-gap: 10px;
  margin: 10px;
}
.bot-grid-container--fit {
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
}
.bot-grid-element {
  cursor: pointer;
  background-color: white;
  padding: 20px;
  border: 1px solid #c9c9c9;
  border-radius: 5px;
  height: 92px;
  text-align: center;
}
.bot-grid-element:hover {
  color: white;
  background: #cd5257;
}
.lila-text {
  border-radius: 50px;
}

.info-icon{
    background: white;
    color: #3a557e;
    border-radius: 50px;
    padding: 0px 10px;
    font-weight: bold;
    cursor: pointer;
    font-family: -webkit-pictograph;
    font-size: 16px;
}
</style>
